import React from 'react';
import PropTypes from 'prop-types';
import { Container, Dot } from './progress-indicator.css';

const ProgressIndicator = ({ steps, progress }) => {
  return (
    <Container>
      {Array(steps)
        .fill('')
        .map((_, i) => i)
        .map((step, i) => (
          <Dot
            key={`step + ${i}`}
            progress={progress}
            steps={steps}
            index={i}
            check={progress > i}
          />
        ))}
    </Container>
  );
};

ProgressIndicator.propTypes = {
  steps: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired,
};

export default ProgressIndicator;
